"use client";

import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { XMarkIcon } from "@heroicons/react/24/outline";

interface SnackbarProps {
  message: string;
  type: "success" | "error" | null | undefined
}

export default function Snackbar({ message, type }: SnackbarProps) {
  const [visible, setVisible] = useState(true);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          className="fixed bottom-6 right-6 z-[9999] "
        >
          <div
            className="relative flex items-center justify-center gap-4 rounded-2xl border p-4 shadow-xl backdrop-blur-md"
            style={
              type === "success"
                ? { backgroundColor: "rgba(0, 79, 59, 1)", borderColor: "rgba(0,79,59,1)", color: "rgba(153, 161, 175, 1)" }
                : type === "error"
                ? { backgroundColor: "rgba(77,2,24,1)", borderColor: "rgba(139, 8, 54, 1)", color: "rgba(255,161,173,1)" }
                : {}
            }
          >
            {/* MESSAGE */}
            <div className="flex-1 text-sm leading-relaxed whitespace-nowrap text-ellipsis overflow-hidden">
              {message}
            </div>

            {/* DISMISS BUTTON */}
            <button
              onClick={() => setVisible(false)}
              className="p-1 hover:opacity-80 transition flex items-center justify-center"
            >
              <XMarkIcon className="h-4 w-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
